import EventBus from '@/scripts/event-bus';
import { ScheduledReportService } from '@/scripts/services/scheduled-reports-service.js';

export const ReportsScheduledWidgetServiceMixin = {
    methods: {
        refreshEvent() {
            EventBus.$emit('scheduled-report:update');
        },

        dispatchGetScheduledReports({ config = {}, accountId = null }) {
            if (accountId) {
                config.filter = config.filter
                    ? `${config.filter} and AccountId eq ${this.accountId}`
                    : `AccountId eq ${this.accountId}`;
            }

            return new Promise((resolve, reject) => {
                ScheduledReportService.getAll(config)
                    .then(({ data: { value } }) => {
                        resolve(value);
                    })
                    .catch(reject);
            });
        },

        dispatchGetReportTypes(tags) {
            const config = {};
            const queryFilters = [];

            if (tags && tags.length) {
                tags.map((tag) => queryFilters.push(`contains(Tags, '${tag}')`));
            }

            if (queryFilters.length) {
                config.filter = `${queryFilters.join(' or ')}`;
            }

            return new Promise((resolve, reject) => {
                ScheduledReportService.getTypes(config)
                    .then(({ data: { value } }) => {
                        resolve(
                            value.map((item) => ({
                                id: item.Id,
                                name: item.Name,
                            }))
                        );
                    })
                    .catch(reject);
            });
        },

        dispatchGetReportFrequencyTypes() {
            return new Promise((resolve, reject) => {
                ScheduledReportService.getFrequencyTypes()
                    .then(({ data: { value } }) => {
                        resolve(
                            value.map((item) => ({
                                id: item.Id,
                                name: item.Name,
                                details: item.Details,
                            }))
                        );
                    })
                    .then(resolve)
                    .catch(reject);
            });
        },

        updateScheduledReport(scheduledReportId, changes) {
            return new Promise((resolve, reject) => {
                ScheduledReportService.patch(scheduledReportId, changes)
                    .then(() => {
                        this.refreshEvent();
                        resolve();
                    })
                    .catch(reject);
            });
        },

        createScheduledReport(payload) {
            return new Promise((resolve, reject) => {
                ScheduledReportService.post(payload)
                    .then(() => {
                        this.refreshEvent();
                        resolve();
                    })
                    .catch(reject);
            });
        },
    },
};
